import { Label as LabelInputDs, Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import { Button } from "ds/Button";
import CheckboxDs from "ds/Checkbox";
import LoadingDefault from "ds/PageLoading";
import * as Sticker from "ds/Sticker";

export const Form = styled.form`
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr max-content;
  background-color: var(--section-snow-background-color, var(--snow));

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 5;
  min-height: 100%;
`;

export const ScrollContainer = styled.div`
  overflow: scroll;
  padding: 0 32px 0 32px;
`;

export const Loading = styled(LoadingDefault)`
  padding-top: unset;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const VendorIconWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 45px;
  height: 32px;

  a {
    background-color: unset;
    &:hover {
      background-color: unset;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
`;

export const ProjectWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin: 0 auto;
`;

export const ManageBackupTitle = styled(Typography.Title)`
  margin: 24px auto 40px auto;
`;

export const ManageBackupDescription = styled(Typography.BodyText)`
  margin: 0 auto;
  text-align: center;
`;

const EnvironmentSelectWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

export const EnvTypeWrapper = styled(EnvironmentSelectWrapper)`
  grid-column: 1 / 3;
`;

export const MaxBackupWrapper = styled(EnvironmentSelectWrapper)`
  grid-column: 3 / 6;
  justify-self: end;
`;

export const LabelInput = styled(LabelInputDs)`
  margin-bottom: 0;
`;

const topFormAlignmentStyles = css`
  display: grid;
  gap: 8px;
  grid-template-columns: 190fr 138px 287px 175px 80px 80fr;

  @media (max-width: 1000px) {
    grid-template-columns: 2fr 138px 287px 175px 80px 1fr;
  }
`;

export const formAlignmentStyles = css`
  display: grid;
  gap: 8px;
  grid-template-columns: 190fr 138px 287px 175px 80px 80fr;

  @media (max-width: 1000px) {
    grid-template-columns: 2fr 138px 287px 175px 80px 1fr;
  }
`;

export const EnvironmentWrapper = styled.div`
  ${topFormAlignmentStyles}
  align-items: center;

  width: 100%;
  margin-top: 40px;
`;

export const HeadRow = styled.div`
  ${topFormAlignmentStyles}
  margin: 40px 0 8px 0;
`;

export const TotalWrapper = styled.div`
  ${formAlignmentStyles}
  border-radius: 8px;
  padding: 16px 0;
  margin-top: 4px;
  margin-bottom: 32px;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
`;

export const BackupsColLabel = styled(Typography.BodyText)`
  padding-left: 8px;
`;

export const TotalBackup = styled(Typography.BodyText)`
  padding-left: 16px;
`;

export const Line = styled.hr`
  background-color: var(--divider-stone-background-color, var(--stone));
  margin: 12px 0px;
`;

export const RevertBtn = styled(Button)`
  margin-left: auto;
`;

export const Checkbox = styled(CheckboxDs)`
  margin: 80px auto 8px auto;
`;

export const Note = styled(Typography.Label)`
  margin: 0 auto;
`;

export const BtnWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 40px auto 52px auto;
`;

export const ReadDocLink = styled(Button)`
  font-size: 15px;
`;

export const ViewPricingBtn = styled(Button)`
  line-height: 16px;
  font-weight: 600;
  font-size: 13px;
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-top: 20px;
`;
